import styled from "styled-components";
import { MEDIA_QUERY } from "../../entities/Common";
import { MixSettingsJarFullness } from "../../entities/Mix";

export const CustomizedStyled = styled.div`
  min-height: 470px;
  margin-bottom: 40px;
  > div {
    min-height: inherit;
  }
  .customized {
    &-information {
      font: normal normal normal 16px/18px Arial;
      font-weight: 800;
      margin-bottom: 10px;
    }
    &-ingredients {
      display: flex;
      margin-bottom: 20px;
      flex-wrap: wrap;
      span {
        color: #bfbfbf;
        font: normal normal normal 16px/18px Arial;
        margin-right: 5px;
        &:last-child {
          margin-right: 0;
        }
      }
    }
    &-center {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 50px;
    }
    &-picture {
      width: 160px;
    }
    &-info {
      width: calc(100% - 180px);
      display: flex;
      justify-content: center;
      align-items: center;
      &__left {
        padding-right: 70px;
        border-right: 1px solid #bfbfbf;
        box-sizing: border-box;
      }
      &__right {
        padding-left: 50px;
        box-sizing: border-box;
      }
    }
    &-group {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }
      label {
        display: block;
        font: normal normal normal 16px/18px Arial;
        margin-bottom: 10px;
      }
      input {
        width: 100px;
        height: 35px;
        border: 1px solid #282828;
        border-radius: 3px;
        font-weight: 700;
        padding-left: 5px;
        box-sizing: border-box;
        outline: none;
        font: normal normal normal 16px/18px Arial 700;
        &[disabled] {
          background-color: rgba(0, 0, 0, 0.16);
        }
      }
    }
    &-price {
      &__group {
        margin-bottom: 20px;
        &:last-child {
          margin-bottom: 0;
          span {
            color: #bfbfbf;
          }
        }
        span {
          display: block;
        }
      }
    }
  }

  .mix-settings {
    &__icon {
      width: 157px;
      height: auto;
      path.jar-line {
        opacity: 0;
        transition: all 0.3s ease-in-out;
      }
      &.${MixSettingsJarFullness.EMPTY} {
        path: {
          opacity: 0;
        }
      }
      &.${MixSettingsJarFullness.ONE_QUARTER} {
        path:nth-last-child(1) {
          opacity: 1;
        }
      }
      &.${MixSettingsJarFullness.HALF} {
        path:nth-last-child(1),
        path:nth-last-child(2) {
          opacity: 1;
        }
      }
      &.${MixSettingsJarFullness.THREE_QUARTERS} {
        path:nth-last-child(1),
        path:nth-last-child(2),
        path:nth-last-child(3) {
          opacity: 1;
        }
      }
      &.${MixSettingsJarFullness.FULL} {
        path:nth-last-child(1),
        path:nth-last-child(2),
        path:nth-last-child(3),
        path:nth-last-child(4) {
          opacity: 1;
        }
      }
    }
  }

  @media (max-width: ${MEDIA_QUERY.MONITOR}) {
    .customized {
      &-info {
        &__left {
          padding-right: 20px;
        }
        &__right {
          padding-left: 20px;
        }
      }
    }
  }

  @media (max-width: ${MEDIA_QUERY.LAPTOP}) {
    .customized {
      &-info {
        display: block;
        &__left {
          padding-right: 0;
          border: none;
          margin-bottom: 10px;
        }
        &__right {
          padding-left: 0;
        }
      }
      &-group {
        margin-bottom: 10px;
        label {
          font: 14px / 16px Arial;
          margin-bottom: 5px;
        }
      }
      &-price {
        &__group {
          margin-bottom: 10px;
          span {
            font-size: 14px;
          }
        }
      }
      &-ingredients span {
        font: 14px / 16px Arial;
      }
      &-information {
        font: 800 14px / 16px Arial;
      }
    }
  }

  @media (max-width: ${MEDIA_QUERY.MOBILE}) {
    margin-bottom: 0;
    .customized {
      &-ingredients {
        span {
          font: 14px / 18px Arial;
        }
      }
      &-group {
        label {
          font: 12px / 16px Arial;
        }
        input {
          height: 30px;
          font-size: 14px;
        }
      }
      &-price {
        &__group {
          margin-bottom: 5px;
          span {
            font-size: 12px;
          }
        }
      }
    }
  }
`;
